import type { TextareaHTMLAttributes } from 'react'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  readonly hasError?: boolean
}

export function Textarea({ hasError = false, className, rows = 4, ...rest }: TextareaProps): JSX.Element {
  const classes = [
    'w-full font-body text-body px-3 py-2 rounded-md resize-y',
    'bg-white border-[1.5px] outline-none transition',
    hasError ? 'border-terra focus:border-terra' : 'border-border focus:border-forest',
    'placeholder:text-stone-400',
    className ?? ''
  ]
    .filter(Boolean)
    .join(' ')

  return <textarea rows={rows} className={classes} {...rest} />
}
